import { render } from "./AppAlertCard.vue?vue&type=template&id=41cab7d4&scoped=true&lang=pug"
import script from "./AppAlertCard.vue?vue&type=script&lang=js"
export * from "./AppAlertCard.vue?vue&type=script&lang=js"

import "./AppAlertCard.vue?vue&type=style&index=0&id=41cab7d4&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cab7d4"]])

export default __exports__